module.exports = __webpack_public_path__ + "img/google-logo.dad2164f.png";